import * as api from '../../requests'
import ls from 'local-storage'
import shortid from 'shortid'

export const setWorkQueueItems = (items, template, category) => ({
  type: 'SET_WORK_QUEUE_ITEMS',
  items,
  template,
  category
})

export const fetchAndSetWorkQueueItems = (category, callback) => (dispatch, getState) => {
  dispatch(setRecordsLoading(true))
  dispatch(setWorkQueueError(null))
  dispatch(setWorkQueueErrorDetails(null))
  const parameters = getState().queue.filters[category] || {}
  const requestId = shortid.generate()
  dispatch(setLastRequestId(requestId))
  api.GET_WORK_QUEUE_ITEMS(
    category,
    parameters,
    requestId,
    (data, props = {}) => {
      if (getState().queue.lastRequestId === props.requestId) {
        dispatch(setWorkQueueItems(data.items, data.template, category))
        dispatch(setRecordsLoading(false))
      }
      if (callback) callback()
    },
    err => {
      dispatch(setRecordsLoading(false))
      dispatch(setWorkQueueError(true))
      dispatch(setWorkQueueErrorDetails({ message: err.Message, code: err.Code }))
    }
  )
}

export const selectWorkQueueItem = (category, selected) => ({
  type: 'SELECT_WORK_QUEUE_ITEM',
  category,
  selected
})

export const setWorkQueueError = error => ({
  type: 'SET_WORK_QUEUE_ERROR',
  error
})

export const setWorkQueueErrorDetails = errorDetails => ({
  type: 'SET_WORK_QUEUE_ERROR_DETAILS',
  errorDetails
})

export const setActiveCategory = category => dispatch => {
  dispatch({
    type: '@@wq/SET_ACTIVE_CATEGORY',
    category
  })
  dispatch({
    type: 'SET_CURRENT_CATEGORY',
    category
  })
}

export const setFilters = (category, filters) => (dispatch, getState) => {
  dispatch({
    type: '@@wq/SET_FILTERS',
    category,
    filters
  })
  ls.set('MY_WORK_QUEUE_FILTERS', { ...getState().queue.filters, [category]: filters })
}

export const setLastRequestId = requestId => ({
  type: '@@wq/SET_REQUEST_ID',
  requestId
})

export const setRecordsLoading = loading => ({
  type: '@@wq/SET_LOADING',
  loading
})

export const invalidateAllCategoryCaches = () => dispatch => {
	dispatch({
		type: '@@wq/INVALIDATE_CACHE'
	})
}



// WEBPACK FOOTER //
// ./src/components/MyWorkQueue/MyWorkQueueActions.js